import { makeRoute } from '~/utils/route';
import controller from './predict-doctype.controller';
import template from './predict-doctype.html';
import './predict-doctype.scss';

export default makeRoute({
	path:           '/predict-doctype',
	template,
	controller,
});
